import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WizardActionService {

  idEmpresa: string;
  idUsuario: string;
  idInstituto: string;
  nombreEmpresa: string;
  nombreUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();


  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
    // this.getInfoEmpresa();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();

    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    console.log(infoUsu);
    this.idEmpresa = infoUsu.empresaId;
    this.nombreUsuario = infoUsu.user;

  }

  puenteDatosActionGo(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getInstituto(){
    this.obtienInfo();
    return this.idInstituto;
  }
  getNombreEmpresa(){
    this.obtienInfo();
    return this.nombreEmpresa;
  }
  getNombreUsuario(){
    this.obtienInfo();
    return this.nombreUsuario;
  }

  getInfoEmpresa(idEmpresa?:string){
    if(localStorage.getItem('idPadre_temporal')){ // ESTA COSA ESTA ASÏ PORQUE LOS CENTROS DE TRABAJO HIJOS DEBEN VER EL FILE MANAGER DEL ADMIN
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + localStorage.getItem('idPadre_temporal'));
    }else{
      if(!idEmpresa){
        return this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + this.idEmpresa);
      }
      else{
        return this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + idEmpresa);
      }
    }
  }

  getProductos(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getProductosEmpresa(idEmpresa:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + idEmpresa);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusModal(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusModal + this.idEmpresa, datos)
  }

  updateStatusModal(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateStatusModal + this.idEmpresa, datos)
  }

  getSeccionesCertificar(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getSeccionesCertificar + this.idEmpresa, datos)
  }

  getSeccionesCertificarDescargaEncuesta(empresaId,datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getSeccionesCertificar + empresaId, datos)
  }


  getSeccionesCertificarT1(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getSeccionesCertificar + this.idEmpresa, datos)
  }

  // SERVICIOS DE CERTIFICAR
  getAllStatus(anio: any){
    let datos: any = {productoId: anio,	idiomas: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatuses + this.idEmpresa, datos);
  }

  guardaStatusStep(datos: any, productoId:any){
    datos.productoId = productoId;
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  getStatusEncuesta(token: any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.fechaCierre.getStatusEncuesta +token );
  }

  estatusDesbloqueoPasos(idProducto: any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.desbloqueoPasos.consultarStatus + this.idEmpresa+'/'+idProducto);
  }

  // SERVICIOS DE MEDIR
  getAllStatusMedir(productoId: string){
    let datos: any = {productoId,	idiomas: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getStatuses + this.idEmpresa, datos);
  }
  guardaStatusStepMedir(datos: any, anio:string){
    datos.productoId = anio;
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
  }
  getStatusModalMedir(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getStatusModal + this.idEmpresa, datos)
  }

  updateStatusModalMedir(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.updateStatusModal + this.idEmpresa, datos)
  }

  // SERVICIOS DE PULSE CHECK
   getAllStatusPulse(productoId: string){
    let datos: any = {productoId,	idiomas: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.statusPaso + this.idEmpresa, datos);

  }
    guardaStatusStepPulse(datos: any, anio: string){
    datos.productoId = anio;
    console.log(datos);

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaStatus + this.idEmpresa, datos);
  }

  getStatusModalPulse(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getStatusModal + this.idEmpresa, datos)
  }

  updateStatusModalPulse(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.updateStatusModal + this.idEmpresa, datos)
  }

  // SERVICIOS DE FOCUS AREA
  getAllStatusFocus(encuestaID: string){
    let datos: any = {encuestaID,	idiomas: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getStatuses + this.idEmpresa, datos);
  }

  guardaStatusStepFocus(datos: any, anio:string){
    datos.encuestaID = anio;
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.guardaStatus + this.idEmpresa, datos);
  }

  getStatusModalFocus(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getStatusModal + this.idEmpresa, datos)
  }

  updateStatusModalFocus(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.updateStatusModal + this.idEmpresa, datos)
  }


}
